import styled from 'styled-components';

const InstrumentPanel = styled.div`
    z-index: 1;
    pointer-events: all;
    background-color: transparent;
    justify-self: center;
    padding: 4px;
    grid-column: instrument-start / instrument-end;
    grid-row: top / timeline-top;
    width: 260px;

    @media (max-width: 1452px) {
        display: none;
    }
`;

export default InstrumentPanel;
